import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  Pager,
  Paging,
  Button,ColumnFixing
} from "devextreme-react/data-grid";
import Guid from "devextreme/core/guid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import "../../modal.css";
import Grid from "@material-ui/core/Grid";
import { api_path } from "../../shared";
function BseGridModal(props) {
  const pageSizes = [25, 50, 100];
  const [GET_LOAD_TYPE, SET_LOAD_TYPE] = useState(props.LOADTYPE);
  const [getBookingData, setBookingData] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getPort, setPort] = useState([]);
  const [portList, setPortList] = useState([]);
  const [selectPort, setSelectPort] = useState([]);
  const [GET_PORT, SET_PORT] = useState("");
  const [GET_BSE, SET_BSE] = useState("");
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getResult, setResult] = useState("");
  useEffect(() => {
    if (props.TYPE == "2") {
      setShow(true);
      fetchSale();
    }else{
      setShow(false);
    }
    if (props.ROLE == "1") {
      setSelectSale(props.CRM_ID);
      setSale({ SALE_CODE: props.CRM_ID, SALE_NAME: props.SALES_NAME });
    }
  }, []);
  useEffect(() => {
    if (
      selectShipper.length == 0 &&
      GET_BSE.length == 0 &&
      GET_PORT.length == 0
    ) {
      setSearchStatus(0);
      setResult("Please fill Shipper,BSE NO or PORT.");
    } else {
      setSearchStatus(1);
      setResult("");
    }
  },);
  const url =
    api_path +
    "/TMP_BSE.php?SALES_CODE=" +
    selectSale +
    "&SHIPPER=" +
    selectShipper +
    "&PORT=" +
    GET_PORT +
    "&docno=" +
    GET_BSE +
    "&LOADTYPE=" + 
    GET_LOAD_TYPE +
    "&search=" +
    getSearchStatus;

  const dataSource = createStore({
    key: "DOCNO",
    loadUrl: `${url}`,
  });
  const fetchSale = () => {
    axios
      .get(
        api_path + `/GET_SALES.php?role=` + props.ROLE + `&user=` + props.CRM_ID
      )
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    if (obj) {
      setSelectSale(obj.SALE_CODE);
      setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
    } else {
      setSelectSale([]);
      setSale([]);
    }
    
  };
  useEffect(() => {
    const getShipperDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/GET_SHIPPER_FROM_BSE.php?SALES_CODE=${getSale.SALE_CODE}&LOADTYPE=${props.LOADTYPE}&TYPE=SHIPPER`
      );
      const getst = resstate.json();
      setShipperList(await getst);
    };
    getShipperDropdown().then();
  }, [getSale.SALE_CODE]);
  const handleShipperChange = (obj) => {
    setSelectPort([]);
    setPort([]);
    if (obj) {
      setSelectShipper(obj.COM_CODE);
      setShipper({
        COM_CODE: obj.COM_CODE,
        COM_NAME: obj.COM_NAME,
      });
    } else {
      setSelectShipper([]);
      setShipper([]);
    }
 
  };
  useEffect(() => {
    const getPortDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/TMP_PORT_BSE.php?SALES_CODE=${props.SALES_CODE}&SHIPPER=${selectShipper}`
      );
      const getst = resstate.json();
      setPortList(await getst);
    };
    getPortDropdown().then();
  }, [selectShipper]);
  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.location = "/s-crm/SalesOrderForm?docno=" + e.row.key + "&loadtype=" + e.row.data.LOADTYPE;
  }, []);
  return (
    <>
      <Modal
        size="xl"
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>BSE DATA</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <label>SALES</label>
              <Select
                className="multiselect1"
                value={getSale}
                options={saleList}
                onChange={handleSaleChange}
                getOptionLabel={(x) => x.SALE_NAME}
                getOptionValue={(x) => x.SALE_CODE}
                isClearable
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <label>SHIPPER</label>
              <Select
                className="multiselect1"
                placeholder="Select..."
                value={getShipper}
                options={shipperList}
                onChange={handleShipperChange}
                getOptionLabel={(x) => x.COM_NAME}
                getOptionValue={(x) => x.COM_CODE}
                isClearable
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <label>BSE NO/BSI NO</label>
              <TextField
                size="small"
                name="GET_BSE"
                variant="outlined"
                fullWidth
                id="GET_BSE"
                value={GET_BSE}
                onChange={(e) => SET_BSE(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <label>DISPORT/DELPORT/FINALPORT</label>
              <TextField
                size="small"
                name="GET_PORT"
                variant="outlined"
                fullWidth
                id="GET_PORT"
                value={GET_PORT}
                onChange={(e) => SET_PORT(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
            <div className="labelError">{getResult}</div>
            </Grid>
          </Grid>
          <Grid container>
            <br />
            <DataGrid
              dataSource={dataSource}
              showBorders={true}
              columnAutoWidth={true}
              rowAlternationEnabled={true}
              showScrollbar={true}
              keyExpr="DOCNO"
            >
              <Scrolling
                rowRenderingMode="virtual"
                showScrollbar="always"
                useNative="false"
                scrollByThumb="true"
              ></Scrolling>
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                width={240}
                placeholder="Full Text Search..."
              />
              <ColumnFixing enabled={true} />
              <Column dataField="DOCNO" caption="DOCNO" width={100}  fixed={true}/>
              <Column dataField="SHIPPER_NAME" caption="SHIPPER" width={200}/>
              <Column dataField="CNEE_NAME" caption="CNEE" width={200}/>
              <Column dataField="LOADTYPE" caption="LOAD TYPE" visible={false}/>
              <Column dataField="POD" caption="POD" width={80} />
              <Column dataField="DEL" caption="DEL" width={80} />
              <Column dataField="FINAL" caption="FINAL" width={80} />
              <Column dataField="ETD" caption="ETD" width={100}
               dataType="date"
               format="dd-MMM-yyyy HH:mm:ss" />
              <Column dataField="CTN20" caption="20'" width={80} />
              <Column dataField="CTN40" caption="40'" width={80} />
              <Column dataField="CTN40HC" caption="40HC'" width={80} />
              <Column dataField="CTN45" caption="45'" width={80} />
              <Column dataField="SALENO" visible={false} />
              <Column type="buttons" width={80}  fixed={true}>
                <Button
                  icon="add"
                  onClick={onEditButtonClick}
                  hint="View details"
                />
              </Column>

              <LoadPanel enabled={true} />
              <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
              <Paging defaultPageSize={25} />
            </DataGrid>
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-primary" onClick={handleClose}>
            Close
          </button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BseGridModal;
